var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevertArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.5C12.7334 15.5 14.1834 15.0601 15.4168 14.236C16.6501 13.4119 17.6114 12.2406 18.1791 10.8701C18.7468 9.49968 18.8953 7.99168 18.6059 6.53683C18.3165 5.08197 17.6022 3.7456 16.5533 2.6967C15.5044 1.64781 14.168 0.933503 12.7132 0.644114C11.2583 0.354725 9.75032 0.50325 8.37987 1.07091C7.00943 1.63856 5.83809 2.59986 5.01398 3.83323C4.18987 5.0666 3.75 6.51664 3.75 8V11.875L1.5 9.625L0.625 10.5L4.375 14.25L8.125 10.5L7.25 9.625L5 11.875V8C5 6.76387 5.36656 5.5555 6.05331 4.52769C6.74007 3.49988 7.71619 2.6988 8.85823 2.22576C10.0003 1.75271 11.2569 1.62894 12.4693 1.8701C13.6817 2.11125 14.7953 2.70651 15.6694 3.58059C16.5435 4.45466 17.1388 5.56831 17.3799 6.78069C17.6211 7.99307 17.4973 9.24974 17.0242 10.3918C16.5512 11.5338 15.7501 12.5099 14.7223 13.1967C13.6945 13.8834 12.4861 14.25 11.25 14.25V15.5Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertArrow);
export default __webpack_public_path__ + "static/media/revert-arrow.7cc3db5ce78ccba9bd200902b1f77788.svg";
export { ForwardRef as ReactComponent };